import { useState, useEffect } from "react";

const useCalculateScale = (
	referenceWidth: number,
	referenceHeight: number,
	useVisualViewport = false
) => {
	const [scale, setScale] = useState(1);

	useEffect(() => {
		const calculateScale = () => {
			const viewport = useVisualViewport ? window.visualViewport : null;
			const windowWidth =
				viewport?.width ?? document.documentElement.clientWidth;
			const windowHeight =
				viewport?.height ?? document.documentElement.clientHeight;
			const scaleX = windowWidth / referenceWidth;
			const scaleY = windowHeight / referenceHeight;
			const scaleFactor = Math.min(scaleX, scaleY);
			setScale(scaleFactor);
		};

		calculateScale();
		window.addEventListener("resize", calculateScale);
		window.visualViewport?.addEventListener("resize", calculateScale);

		return () => {
			window.removeEventListener("resize", calculateScale);
			window.visualViewport?.removeEventListener("resize", calculateScale);
		};
	}, [referenceWidth, referenceHeight, useVisualViewport]);

	return scale > 1 ? 1 : scale;
};

export default useCalculateScale;
